import { BaseStore, getOrCreateStore } from '@Di'
import { action, observable } from 'mobx'

class MemberStore extends BaseStore {
  @observable byHub = observable.map()

  @action
  load(role, hubId, users, append = false) {
    let byRole = this.byHub.get(String(hubId))

    if (!byRole) {
      byRole = observable.map({})
      this.byHub.set(String(hubId), byRole)
    }

    const usersList = users.reduce(
      (arr, user) => {
        arr.push({
          id: user.id,
          role: user.role,
          score: user.score,
        })
        return arr
      },
      append ? byRole.get(role) || [] : []
    )

    byRole.set(role, usersList)
  }

  /**
   * ToDo: move UsersStore to Di
   */
  requestRole = async (role, hubId, q, UsersStore) => {
    try {
      const roleQuery = role === 'collaborator' ? 'collaborator,moderator,owner' : role

      const resp = await this.request({
        path: `/hubs/${hubId}/users/`,
        query: { q, role: roleQuery, order_by: 'name' },
      })

      UsersStore.load(resp.data)
      this.load(role, hubId, resp.data)
    } catch (e) {
      console.error(e)
    }
  }
}

export default getOrCreateStore('MemberStore', MemberStore)
